<div class="w-full flex flex-col sm:flex-row justify-between py-2 gap-2 items-center">
  <div class="flex items-center gap-2 bg-white py-1 px-2 sm:py-2 rounded-full">
    <img
      class="h-[20px] w-[20px]"
      src="assets/icons/info-24px.svg"
      style="filter: invert(71%) sepia(9%) saturate(246%) hue-rotate(169deg) brightness(87%) contrast(88%);"
    />
    <div class="flex flex-col rounded-full bg-white text-sm sm:text-base text-center sm:text-left">
      <span class="font-semibold">Neue Einwilligung erforderlich</span>
      <span class="text-xs">
        Um den Kontakt mit Ihnen weiterhin optimal gestalten zu können, bitten wir Sie, Ihre Einwilligung(en)
        in wenigen Schritten zu erneuern. Vielen Dank für Ihre Unterstützung!
      </span>
    </div>
  </div>

  <div>
    <button
      class="text-white text-sm sm:text-base rounded-full py-1 px-2 sm:py-2 font-semibold w-[100px]"
      [ngClass]="
      brand.isLexus()
      ? 'bg-lexusBlue hover:bg-lexusBlueDark'
      : 'bg-toyotaRed hover:bg-toyotaRedDark'
      "
      (click)="openWizard()"
    >
      <span>Starten</span>
    </button>
  </div>
</div>
